export const predefinedImages = {
	blogCoverImage: {
		src: 'https://images.unsplash.com/photo-1436262513933-a0b06755c784…tropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjcyNTgzfQ',
		alt: 'woman wearing black top standing near yellow wall',
	},
};
